'use client';

import { Link } from '@coolblue-development/freddy';
import clickReviewsInProductInformationTrigger from '@coolblue-development/ga4-events/triggers/ProductInformation/clickReviewsInProductInformationTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import type { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { useTranslation } from '@i18n/useTranslation';
import { scrollToTarget } from '@utils/utils';

export default function ExpertReviewLink({
  reviewsSectionId,
  product
}: {
  reviewsSectionId: string;
  product: Product | MainProduct;
}) {
  const { trackEvent } = useAnalytics();
  const { t } = useTranslation('webshop.productPage.productInformation');

  const params = {
    item_id: product.id
  };

  return (
    <Link
      href={`#${reviewsSectionId}`}
      startIcon={<ArrowRight />}
      mt={200}
      onClick={event => {
        scrollToTarget(reviewsSectionId)(event);
        trackEvent(clickReviewsInProductInformationTrigger(params));
      }}
    >
      {t('readExpertReview')}
    </Link>
  );
}
